import SmallButton from './SmallButton';
export default SmallButton;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/DriversTable/SmallButton/index.js